// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { RealtimeEvent } from '@atlassian/jira-polaris-realtime/src/common/types/events.tsx';
import type { State } from '../../types.tsx';

export const addDeferredEvent =
	(realTimeEvents: RealtimeEvent[]) =>
	({ getState, setState }: StoreActionApi<State>) => {
		const state = getState();

		const evenTypeList: RealtimeEvent[] = state.defferRealTimeEvents
			? [...state.defferRealTimeEvents, ...realTimeEvents]
			: realTimeEvents;

		setState({
			...state,
			defferRealTimeEvents: evenTypeList,
		});
	};

export const pauseRealtimeEvents =
	() =>
	({ getState, setState }: StoreActionApi<State>) => {
		const state = getState();

		setState({
			...state,
			defferRealTimeEventsCounter: (state.defferRealTimeEventsCounter ?? 0) + 1,
		});
	};

export const resumeRealtimeEvents =
	() =>
	({ getState, setState }: StoreActionApi<State>) => {
		const state = getState();
		if (!state.defferRealTimeEventsCounter) {
			return [];
		}

		const counter = state.defferRealTimeEventsCounter - 1;

		if (counter <= 0) {
			const removedItems = [...(state.defferRealTimeEvents ?? [])];
			setState({
				...state,
				defferRealTimeEvents: [],
				defferRealTimeEventsCounter: 0,
			});
			return removedItems;
		}

		setState({
			...state,
			defferRealTimeEventsCounter: counter,
		});
		return [];
	};
